import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { prettyDate, prettyFloatMoney } from '@/helpers/utils';
import { DATE_FORMAT_MMM_YYYY } from '@/helpers/common';
import { EmptyContent } from '@/components/TaxReport/EmptyContent';
import { Preloader } from '@/components/Preloader';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { PortfolioMovementDetailModal } from '@/modals/PortfolioMovementDetailModal';
import s from './index.module.scss';

export const List = ({ data, grouping, isLoading }) => {
  const [selected, setSelected] = useState(null);
  const { t } = useTranslation('reports');
  const { openSingleModal } = useModal();

  const onDetailClick = report => {
    setSelected(report);
    openSingleModal(MODAL_IDS.portfolio_movement_detail);
  };

  if (isLoading) {
    return <Preloader className={s.preloader} />;
  }

  if (!isLoading && !data?.total_count) {
    return (
      <div className={s.empty}>
        <EmptyContent />
      </div>
    );
  }

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <div className="f-tiny-accent">
          {grouping
            ? t('portfolio_data.round_invested')
            : t('portfolio_data.claim_invested')}
        </div>
        <div className="f-tiny-accent">
          {t('portfolio_data.closing_principal')}
        </div>
      </div>
      <div className={s.list}>
        {data.list.map((item, index) => (
          <div
            className={s.item}
            key={index}
            onClick={() => onDetailClick(item)}
          >
            <div className={s.left}>
              <div className="f-body-accent">
                {grouping
                  ? prettyDate(
                      item.fundraising_start_date,
                      DATE_FORMAT_MMM_YYYY,
                    )
                  : `#${item.loan_id}`}
              </div>
              <div className="f-small-regular">
                {prettyFloatMoney(item.invested, {
                  decimalPlaces: 2,
                })}
              </div>
            </div>
            <div className={s.right}>
              <div className="f-body-accent">
                {prettyFloatMoney(item.closing_principal, {
                  decimalPlaces: 2,
                })}
              </div>
            </div>
          </div>
        ))}
      </div>
      <PortfolioMovementDetailModal data={selected} grouping={grouping} />
    </div>
  );
};
